<div class="patient-summary-wrapper">
  <!-- Core Patient Chips -->
  <div class="detail-matrix mb-3">
    <div class="detail-chip">
      <span class="detail-chip__label">Name</span>
      <span class="detail-chip__value"
        >{{ booking?.patient?.firstName }} {{ booking?.patient?.lastName }}</span
      >
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Age / Gender</span>
      <span class="detail-chip__value"
        >{{ booking?.patient?.dateOfBirth ?? '' | age }} yrs &bull;
        {{ booking?.patient?.gender || '—' }}</span
      >
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Appointment</span>
      <span class="detail-chip__value"
        >{{ booking?.bookingSlot?.slotDate | date: 'dd MMM yyyy' }} at
        {{ booking?.bookingSlot?.slotTime }}</span
      >
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Medical Aid Scheme</span>
      <span class="detail-chip__value">{{
        booking?.patient?.clinicPatient?.medicalAidScheme || '—'
      }}</span>
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Medical Aid Number</span>
      <span class="detail-chip__value">{{
        booking?.patient?.clinicPatient?.medicalAidNumber || '—'
      }}</span>
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Plan</span>
      <span class="detail-chip__value">{{
        booking?.patient?.clinicPatient?.medicalAidPlan || '—'
      }}</span>
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Blood Type</span>
      <span class="detail-chip__value">{{ booking?.patient?.bloodType || '—' }}</span>
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Height / Weight</span>
      <span class="detail-chip__value"
        >{{ booking?.patient?.height ? booking?.patient?.height + ' cm' : '—' }} &bull;
        {{ booking?.patient?.weight ? booking?.patient?.weight + ' kg' : '—' }}</span
      >
    </div>

    <div class="detail-chip">
      <span class="detail-chip__label">Chronic Illness</span>
      <span class="detail-chip__value">{{
        booking?.patient?.chronicIllness || 'None reported'
      }}</span>
    </div>
  </div>

  @if (booking?.patient?.medicalHistorySummary) {
    <div class="notes-card notes-card--soft mb-3">
      <span class="notes-card__label">Medical History Summary</span>
      <p class="notes-card__body mb-0">{{ booking?.patient?.medicalHistorySummary }}</p>
    </div>
  }

  @if (booking?.patient?.allergies?.length) {
    <div class="allergies-card mb-3">
      <span class="detail-chip__label mb-2">Known Allergies</span>
      <div class="d-flex flex-wrap gap-1">
        @for (allergy of booking?.patient?.allergies; track $index) {
          <span
            class="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 rounded-pill"
          >
            <i class="bi bi-exclamation-circle me-1"></i>{{ allergy }}
          </span>
        }
      </div>
    </div>
  }

  @if (!!emergencyContact) {
    <div class="emergency-contact-card mt-3">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <span class="emergency-contact-label">
          <i class="bi bi-telephone-fill me-1 text-danger"></i>Emergency Contact
        </span>
        <span class="badge bg-secondary-subtle text-secondary rounded-pill">{{
          emergencyContact.relationship
        }}</span>
      </div>
      <div class="emergency-contact-name">
        {{ emergencyContact.firstName + ' ' + emergencyContact.lastName }}
      </div>
      <div class="emergency-contact-phone">
        <a [href]="'tel:' + emergencyContact.phoneNumber" class="text-decoration-none text-primary">
          <i class="bi bi-phone me-1"></i>{{ emergencyContact.phoneNumber }}
        </a>
      </div>
    </div>
  }
</div>
